/**
 * Вступление, которое человек видит до входа, методички пишут отдельным
 * разделом: «## Вступление, которое Егор увидит до входа». Поле в админке его
 * не подхватывало, и 12.10.2026 нашлось: из трёх сентябрьских брифов в двух
 * вступление написали заново вместо текста из методички. Раздел — тот, чей
 * заголовок начинается словом «Вступление»; цитата `> ` снимается, потому что
 * на странице входа markdown не рисуется.
 */
export function introFrom(guide: string): string {
  const lines = guide.split(/\r?\n/u);
  const start = lines.findIndex((line) => introHeading.test(line));
  if (start === -1) {
    return "";
  }
  const level = headingLevel(lines[start] ?? "");
  const body: string[] = [];
  for (const line of lines.slice(start + 1)) {
    const next = headingLevel(line);
    if (next > 0 && next <= level) {
      break;
    }
    body.push(line.replace(/^\s*>\s?/u, ""));
  }
  return body.join("\n").trim();
}

const introHeading = /^\s{0,3}#{1,6}[\t ]+вступлени/iu;

function headingLevel(line: string): number {
  return /^\s{0,3}(#{1,6})[\t ]/u.exec(line)?.[1]?.length ?? 0;
}
